class CustomPromoCountdown extends HTMLElement {
  constructor() {
    super();
    
    // 从 HTML data-* 属性获取时间数据并转换为 Date 对象
    this.stage1Date = new Date(this.dataset.stage1Date);
    this.stage2Date = new Date(this.dataset.stage2Date);
    // 测试数据
    // this.stage1Date = new Date('2025-08-27T19:15:12');
    // this.stage2Date = new Date('2025-08-27T19:17:13');
    
    this.currentStage = 1;
    this.interval = null;
  }

  connectedCallback() {
    // 确保元素完全挂载后再调用 init
    setTimeout(() => {
      this.getAllElements();
      this.init();
      this.bandSubmit();
    }, 0);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  getAllElements() {
    this.errorGroup = document.getElementById('error-group');
    this.agreeGroup = document.getElementById('agree-group');
    this.successIcon = document.getElementById('success-icon');
    this.subButton = document.getElementById('subscribe-button');
    this.successText = this.subButton.dataset.successText;
    this.errorIcon = document.getElementById('error-icon');
    this.tipLabel = document.getElementById('tip-label');
    this.buyButton = document.getElementById('buy-button');
    this.emailInput = document.querySelector('.stage-email-input');
    this.agreeCheckbox = document.getElementById('agree');
    this.errorText = this.subButton.dataset.errorText
    this.checkText = this.subButton.dataset.checkText
  }

  init() {
    this.updateStage();
    // 初始化时强制更新一次内容，确保显示正确的阶段文案
    this.updateAllContent(this.currentStage);
    this.startTimer();
  }

  updateStage() {
    const now = new Date();
    let stage;

    // 计算时间差
    const diff1 = this.stage2Date - now; // 当前时间到活动结束时间
    const diff2 = this.stage2Date - this.stage1Date; // 活动总时长

    // 判断当前阶段
    if (diff1 < 0) {
      stage = 'ended'; 
    } else {
      if (diff1 > diff2) {
        stage = 1; // 预热期
      } else if (diff1 > 0) {
        stage = 2; // 活动期
      } else {
        stage = 'ended'; // 活动结束
      }
    }

    // 倒计时目标始终是活动结束时间
    this.targetDate = stage === 'ended' ? null : this.stage2Date;

    // 如果阶段发生变化，更新内容
    if (this.currentStage !== stage) {
      this.updateAllContent(stage);
    }
    
    this.currentStage = stage;
  }



  updateAllContent(stage) {
    this.updateHeadings(stage);
    this.updateTexts(stage);
    this.updateButtons(stage);
  }

  updateButtons(stage) {
    
    const inputButtonForm = document.querySelector('.stage-input-button-form');
    const singleButton = document.getElementById('submit-button');
    const submitButton = document.querySelector('.stage-submit-button');
    
    if (stage === 1) {
      // 预热阶段：显示输入框+按钮
      if (inputButtonForm) inputButtonForm.style.display = 'block';
      if (singleButton) singleButton.style.display = 'none';
      
      // 更新提交按钮的文案和样式
      if (submitButton) {
        const stageText = submitButton.dataset[`stage${stage}Text`];
        const stageBg = submitButton.dataset[`stage${stage}Bg`];
        const stageColor = submitButton.dataset[`stage${stage}Color`];
        
        if (stageText) {
          submitButton.textContent = stageText;
        }
        if (stageBg) {
          submitButton.style.backgroundColor = stageBg;
        }
        if (stageColor) {
          submitButton.style.color = stageColor;
        }
      }
    } else {
      // 活动及结束阶段：显示单按钮
      if (inputButtonForm) inputButtonForm.style.display = 'none';
      if (singleButton) singleButton.style.display = 'flex';
      this.errorGroup.style.display = 'none';
      this.agreeGroup.style.display = 'none';
      
      // 更新单按钮的文案和样式
      const stageText = stage === 2 ? this.buyButton.dataset[`stage${stage}Text`] : this.buyButton.dataset[`endText`];
      const stageBg = stage === 2 ? this.buyButton.dataset[`stage${stage}Bg`] : this.buyButton.dataset[`endBg`];
      const stageColor = stage === 2 ? this.buyButton.dataset[`stage${stage}Color`] : this.buyButton.dataset[`endColor`];
      
      if (stageText) {
        this.buyButton.textContent = stageText;
      }
      if (stageBg) {
        this.buyButton.style.backgroundColor = stageBg;
      }
      if (stageColor) {
        this.buyButton.style.color = stageColor;
      }
    }
  }

  updateHeadings(stage) {    
    // 尝试更简单的选择器
    const headings = this.querySelectorAll('.countdown-heading');
    headings.forEach(heading => {
      const stageText = stage === 'ended' 
        ? heading.dataset.endedText 
        : heading.dataset[`stage${stage}Text`];
      
      if (stageText) {
        heading.textContent = stageText;
      }
    });
  }

  updateTexts(stage) {
    const texts = this.querySelectorAll('[data-stage-content="text"]');
    texts.forEach(text => {
      const stageText = stage === 'ended' 
        ? text.dataset.endedText 
        : text.dataset[`stage${stage}Text`];
      
      if (stageText) {
        text.innerHTML = stageText;
      }
    });
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.updateStage();
      
      if (this.currentStage === 'ended') {
        const numbers = this.querySelectorAll('.countdown-number');
        const numberBoxes = this.querySelectorAll('.countdown-number');
        numbers.forEach(number => {
          number.textContent = '00';
        });
        numberBoxes.forEach(box => {
          box.style.color = '#A3A3A3';
        });
        
        // 倒计时结束，清除定时器
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
          console.log('倒计时已结束，定时器已清除');
        }
        return;
      }

      this.updateCountdown();
    }, 1000);

    // 立即更新一次
    this.updateCountdown();
  }

  updateCountdown() {
    // 根据当前阶段动态设置倒计时目标
    let targetDate;
    if (this.currentStage === 1) {
      // 预热期：倒计时到活动开始
      targetDate = this.stage1Date;
    } else if (this.currentStage === 2) {
      // 活动期：倒计时到活动结束
      targetDate = this.stage2Date;
    } else {
      // 活动结束
      return;
    }

    const now = new Date();
    const diff = targetDate - now;
    const numbers = this.querySelectorAll('.countdown-number');

    if (diff <= 0) {
      this.updateStage();
      // 如果倒计时结束，清除定时器
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        console.log('倒计时在updateCountdown中结束，定时器已清除');
      }
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // 更新所有倒计时数字
    if (numbers.length >= 4) {
      numbers[0].textContent = String(days).padStart(2, '0');
      numbers[1].textContent = String(hours).padStart(2, '0');
      numbers[2].textContent = String(minutes).padStart(2, '0');
      numbers[3].textContent = String(seconds).padStart(2, '0');
    }
  }

  isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  clearTips() {
    this.errorIcon.classList.add('hidden');
    this.successIcon.classList.add('hidden');
     this.tipLabel.textContent = '';
  }

  requestJson(url, options = {}) {
    const baseUrl = window.baseUrl; // fallback
    return fetch(baseUrl + url, {
      headers: {
        'wb-api-key': 'd1befa03c79ca0b84ecc488dea96bc68',
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      ...options
    }).then(res => res.json());
  };

  async submitSubscribeForm(data) {
      try {
        let site = window.site
        const recaptchaToken = await window.getRecaptchaToken();
        data.recaptchaToken = recaptchaToken;
        const res = await this.requestJson(`/newOfficialWebsite/customer/addCustomerInfo?site=${site}`, {
          method: 'POST',
          body: JSON.stringify(data)
        });

        if (res && res.code === 200) {
          // 切换展示成功提示
          this.errorGroup.style.display = 'flex';
          this.errorIcon.classList.add('hidden');
          this.successIcon.classList.remove('hidden');
          this.tipLabel.textContent = this.successText;
          this.errorGroup.style.color = 'white';
        } else {
          console.warn('提交失败', res);
        }
      } catch (err) {
        console.error('请求失败', err);
      } finally {
        // 提交完成，重置loading & 禁用按钮
        this.subButton.disabled = false;
        this.subButton.classList.remove('loading');
        this.subButton.textContent = this.subButton.dataset[`stage1Text`];
      }
    }

  bandSubmit() {
    this.buyButton.addEventListener('click', () => {
      const targetId = this.buyButton.dataset.stage2TargetId;
      const linkUrl = this.buyButton.dataset.stage2LinkUrl;
      if (targetId) {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (linkUrl) {
        window.location.href = linkUrl;
      }
    });

    this.subButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.clearTips();
      let hasError = false;

      if (!this.emailInput.value.trim() || !this.isValidEmail(this.emailInput.value)) {
        hasError = true;
        this.errorGroup.style.display = 'flex';
        this.errorIcon.classList.remove('hidden');
        this.tipLabel.textContent = this.errorText;
        this.errorGroup.style.color = 'black';
        return;
      }

      if (!this.agreeCheckbox.checked) {
        hasError = true;
        this.errorGroup.style.display = 'flex';
        this.errorIcon.classList.remove('hidden');
        this.tipLabel.textContent = this.checkText;
        this.errorGroup.style.color = 'black';
        return;
      }

      if (hasError) return;

      this.subButton.disabled = true;
      this.subButton.classList.add('loading');
      this.subButton.textContent = '';

      const email = this.emailInput.value.trim();
      const pathname = window.location.pathname;
      const country = `{{ localization.country.iso_code }}` || 'UNKNOWN'; // default NL
      const data = {
        email,
        tags: `${country},${pathname}`,
        emailMarketingConsent: {
          marketingState: 'SUBSCRIBED',
          marketingOptInLevel: 'SINGLE_OPT_IN'
        }
      };
      this.submitSubscribeForm(data);
    });
  }


}

// 注册自定义元素
customElements.define('custom-promo-countdown', CustomPromoCountdown);